import { LoginRecoveryState } from '@pages/login-recovery-options/store/state/login-recovery.state';

export const loginRecoveryState = [LoginRecoveryState];
